import React from 'react'

const FAQ = () => {
  return (
    <div className='container-fluid fs-4'>
      <div className='m-4 p-4'>
        <h1 className='text-light text-center'>FAQ</h1>
        <div className='text-light mt-4'>
          <h4>1. Will DocKing have a version for Windows?</h4>
          <p>Yes, DocKing will have a version available for Windows. Stay tuned for updates on the official release!</p>
          
          <h4>2. Is there a user manual available for DocKing?</h4>
          <p>Currently, the user manual is under development. We aim to provide a comprehensive guide soon to help you make the most out of DocKing.</p>
        </div>
      </div>
    </div>
  )
}

export default FAQ
